import locale from "@bonliva-crm/locale";
import { QualityCheckButton } from "../quality-check-button";
import { QualityCheck, QualityCheckProps } from "../quality-check";
import { HlrLabel } from "./hlr-label";
import { useHLRRequestOrder } from "./use-hlr-request-order";

export const hlrNames = ["HLR", "S-HLR Barn", "S-HLR Vuxen", "A-HLR Vuxen", "A-HLR Barn"];

export function HlrQualityCheck(props: QualityCheckProps) {
  if (!hlrNames.includes(props.data.Name)) {
    throw new Error("Wrong component");
  }

  const { data, consultantData } = props;

  const isSAHLR = props.data.Name !== "HLR";

  const { onRequestOrder, loading } = useHLRRequestOrder({
    data,
    consultantData,
    orderOptions: {
      maxPlaceSymbolLength: 35
    }
  });

  return (
    <QualityCheck
      renderLabel={(label) => <HlrLabel label={label} qcName={data.Name} />}
      renderExtraAction={() =>
        isSAHLR && (
          <QualityCheckButton
            text={locale.Order}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onRequestOrder();
            }}
            disabled={loading || props.data.Disabled}
            loading={loading}
          />
        )
      }
      {...props}
    />
  );
}
